import React from 'react';

import Text from '/component/base/Text';
import {capGQV} from '/util/attribute.util';
import {getFontFamily} from '/util/text.util';

const boldedStyle = getFontFamily('bold');
interface Volume {
  gqv?: number | string;
}
interface PersonStatsProps {
  count: number;
  target: number;
  subheaderFirst: string | null;
  subheaderSecond: string | null;
  volume: Volume;
}

export const PersonStats: React.FC<PersonStatsProps> = ({
  count = 0,
  target = 0,
  subheaderFirst = '',
  subheaderSecond = '',
  volume: {gqv} = {},
}) => {
  return (
    <Text allowFontScaling maxFontSizeMultiplier={2} emphasis="medium">
      <Text
        allowFontScaling
        maxFontSizeMultiplier={2}
        emphasis="medium"
        style={boldedStyle}>
        {`${subheaderFirst} `}
      </Text>
      {count}/{target}
      <Text allowFontScaling maxFontSizeMultiplier={2} emphasis="medium">
        {' '}
        -{' '}
      </Text>
      <Text
        allowFontScaling
        maxFontSizeMultiplier={2}
        emphasis="medium"
        style={boldedStyle}>
        {`${subheaderSecond}`}
      </Text>
      {capGQV(gqv)}
    </Text>
  );
};
